const OrderStrategy = (id, name) => {
    return {
        id,
        name
    }
}

export default OrderStrategy;